


<script setup>
    import {defineProps, watchEffect, ref} from "vue";
    const props = defineProps(["displayData"]);
    let dataIndex = 0;

    //Saving as array will let us use list transitions more easily
    const internalDisplayData = ref([]);


    //Now we can seperate out new values and vue will add in list animations
    watchEffect(() =>{
        if(props.displayData !== undefined){
            let newVal =  JSON.parse(JSON.stringify(props.displayData));

            internalDisplayData.value = [{value: newVal, index: dataIndex++}];
        }
    })


</script>

<template>
    <span>
       <TransitionGroup name = "elementTransition">
            <template v-for="data in internalDisplayData" :key = "data.index"><span><slot v-bind="data" ></slot></span></template>
        </TransitionGroup>
    </span>
</template>

<style scoped>

.elementTransition-move, .elementTransition-enter-active, .elementTransition-leave-active{
    transition: opacity 1s ease, transform 10s ease;
}

.elementTransition-enter-from, .elementTransition-leave-to {
    opacity: 0;
}

.elementTransition-leave-active{
    position: absolute;
}

</style>